/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MstCenterStockItemUpdateBase } from './MstCenterStockItemUpdateBase';
import {
    MstCenterStockItemUpdateBaseFromJSON,
    MstCenterStockItemUpdateBaseFromJSONTyped,
    MstCenterStockItemUpdateBaseToJSON,
    MstCenterStockItemUpdateBaseToJSONTyped,
} from './MstCenterStockItemUpdateBase';

/**
 * 
 * @export
 * @interface MstCenterStockItemUpdate
 */
export interface MstCenterStockItemUpdate {
    /**
     * 
     * @type {Array<MstCenterStockItemUpdateBase>}
     * @memberof MstCenterStockItemUpdate
     */
    body: Array<MstCenterStockItemUpdateBase>;
}

/**
 * Check if a given object implements the MstCenterStockItemUpdate interface.
 */
export function instanceOfMstCenterStockItemUpdate(value: object): value is MstCenterStockItemUpdate {
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function MstCenterStockItemUpdateFromJSON(json: any): MstCenterStockItemUpdate {
    return MstCenterStockItemUpdateFromJSONTyped(json, false);
}

export function MstCenterStockItemUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MstCenterStockItemUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'body': ((json['body'] as Array<any>).map(MstCenterStockItemUpdateBaseFromJSON)),
    };
}

export function MstCenterStockItemUpdateToJSON(json: any): MstCenterStockItemUpdate {
    return MstCenterStockItemUpdateToJSONTyped(json, false);
}

export function MstCenterStockItemUpdateToJSONTyped(value?: MstCenterStockItemUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': ((value['body'] as Array<any>).map(MstCenterStockItemUpdateBaseToJSON)),
    };
}

